// Initialize Firebase
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import online from './status.js';

/*
  Identity Platform console (not configurable from this repo):
  1. Authentication > Settings > Password policy: minimum 10 characters,
     require lowercase, uppercase, numeric, and non-alphanumeric characters.
     Enforce on sign-up and password change. Existing passwords keep working
     until the user changes them.
  2. Authentication > Settings > User actions: enable email enumeration
     protection so createAuthUri and sendOobCode stop disclosing whether an
     address is registered.
  3. Authentication > Settings: enforce reCAPTCHA Enterprise / App Check on
     email/password sign-in, sign-up, and password reset. Restrict the web API
     key HTTP referrers to app.closedcaptioncreator.com, localhost, and the
     packaged-app origins you actually use. Set VITE_RECAPTCHA_ENTERPRISE_SITE_KEY
     so this client can mint App Check tokens.
  4. Enable MFA for admin@, support@, and info@ closedcaptioncreator.com.
  Do not enforce App Check on Cloud Functions until every client ships with
  App Check initialized.
*/
const config = {
    apiKey: "AIzaSyBwFMusZjo7iqYk63nCFYM-64negqrWrxE",
    authDomain: "closed-caption-creator-app.firebaseapp.com",
    databaseURL: "https://closed-caption-creator-app.firebaseio.com",
    projectId: "closed-caption-creator-app",
    storageBucket: "closed-caption-creator-app.appspot.com",
    messagingSenderId: "472541817513",
    appId: "1:472541817513:web:60ce40822728e2a78157b8"
  };

const recaptchaEnterpriseSiteKey = import.meta.env?.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY;

let app = null;
if (online) {
    if (getApps().length === 0) {
        app = initializeApp(config);
        if (recaptchaEnterpriseSiteKey) {
            initializeAppCheck(app, {
                provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
                isTokenAutoRefreshEnabled: true,
            });
        }
    } else {
        app = getApp();
    }
}

export const auth = app ? getAuth(app) : null;
export const functions = app ? getFunctions(app) : null;
export { app };
export default app;
